import React from 'react'

function Loader() {
  return (
    <div className='mt-5 '>
    <div className='d-flex justify-content-center'>
    <div className="spinner-border" style={{width: '3rem', height: '3rem'}} role="status">
    </div>
    </div>
    </div>

  )
}

export default Loader